const CONSTANTS = {
    COUNTRY: {
        SPAIN: 67,
        ITALY: 107
    },
    COUNTRIES_HISPANOHABLANTES: [
        228, 223, 193, 176, 168, 166, 157, 136, 95, 89, 67, 63, 61, 51, 48, 41, 30, 9, 6
    ],
    CONFIGURACION_TICKET: {
        FACTURA_SIMPLIFICADA: 1,
        TICKET_ESTANDAR: 2
    },
    ESTADOS_PEDIDO: {
        PENDIENTE: 1,
        REALIZADO_PENDIENTE: 2,
        RECIBIDO: 3,
        CANCELADO: 4,
        ENCAMINO_ENVIADO: 5
    },
    FORMAS_PAGO: {
        EFECTIVO: 1,
        TARJETA: 2,
        VALE: 3,
        TRANSFERENCIA: 4,
        FINANCIERA: 5,
        MIXTO: 6,
        PAYPAL: 7,
        ONLINE: 8,
        BIZUM: 9,
        TARJETA_REGALO: 10,
        TARJETA_FIDELIDAD: 11,
    },
    FORMAS_PAGO_ECOMMERCE: {
        TARJETA: 1,
        PAYPAL: 2,
        CONTRAREEMBOLSO: 3,
        RECOGIDA_EN_TIENDA: 4,
    },
    PLANES_KOIBOX: {
        CRM: 1,
        CRM_SMS: 5,
        BASIC: 12,
        GOLD: 13,
        PLATINUM: 14,
        LITE: 15,
        SKEYNDOR: 16,
        WHATSAPP_LITE: 17,
        WHATSAPP_BASIC: 18,
        PACK_100_SMS: 7,
        PACK_500_SMS: 8,
        PACK_1000_SMS: 9,
        PACK_3000_SMS: 10
    },
    DUPLICAR_CLIENTE:{
        MOVIL: 'D001',
        FIJO: 'D002',
        EMAIL: 'D003',
        DNI: 'D004',
        NOMBRE_COMPLETO: 'D005',
    },
    DISTRIBUIDORES: {
        KOIBOX: 1,
        VICTOR_SALVADOR: 2,
        NYOTHA: 3,
        SKEYNDOR: 4,
        WELLA: 10,
        VAGHEGGI: 12,
        INSIDE_SALONS: 13,
        SEBYMAR: 14,
    }
}

export default CONSTANTS
